import React from 'react'
import { Typography } from '@mui/material'
import useStyles from './styles'

const PageHeaderSubtitle = (props: any) => {
  const { className, children, variant, ...restProps } = props
  const { classes } = useStyles()

  const getClassName = () => {
    const classList = [classes.container]

    if (className) {
      classList.push(className)
    }

    if (variant === 'center') {
      classList.push(classes.center)
    }

    return classList.join(' ')
  }

  return (
    <div className={getClassName()} {...restProps}>
      <Typography variant="h4" component="div">
        {children}
      </Typography>
    </div>
  )
}

export default React.memo(PageHeaderSubtitle)
